import React, { Fragment } from "react";
// Utils
import { responseDownloadFileErrors } from "utils";
//  COMPONENTS
import { Box } from "@mui/material";
import { LinkFile } from "components/UI";
import { TEMPLATE_NAME } from "pages/Forecast/ApmcForecastScreen/constants/apmc.type.js";
import { API_NAME_APMC, COMMON_ENUM, TEMPLATE_FILE_CODE } from "shared/constants";
//API
import { useDownloadTemplateMutation } from "shared/services/inventory-forecast";
import { useLoadingContext } from "shared/contexts/LoadingContext";
export default function TemplateBar({ setMsg: { setMsgError, setMsgAlert }, tabIndex = -1 }) {
  const exportTemplate = useDownloadTemplateMutation();
  const { startLoading, stopLoading } = useLoadingContext();
  // ? HANDLE LINK DOWNLOAD FILE TEMPLATE
  const handleDownloadTemplate = async name => {
    setMsgError([]);
    setMsgAlert([]);
    try {
      const infoFile = TEMPLATE_FILE_CODE.find(v => v.value === name);
      const body = { [API_NAME_APMC.DATA_OWNER]: COMMON_ENUM.C_SM_CTG_TMAP_EM, cd: infoFile?.cd };
      startLoading();
      await exportTemplate(body);
      stopLoading();
    } catch (error) {
      stopLoading();
      const err = responseDownloadFileErrors(error);
      setMsgError(err);
      window.scroll(0, 0);
      return;
    }
  };
  return (
    <Fragment>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
        <LinkFile
          id={TEMPLATE_NAME.PRODUCTION}
          component="button"
          variant="body2"
          value={TEMPLATE_NAME.PRODUCTION}
          onClick={() => handleDownloadTemplate("Production Plan")}
          props={{
            tabIndex,
          }}
        />
        <div style={{ marginRight: "8px" }}> |</div>
        <LinkFile
          id="plan-template-packing"
          component="button"
          variant="body2"
          value={TEMPLATE_NAME.PACKING}
          onClick={() => handleDownloadTemplate("Packing Plan")}
          props={{
            tabIndex,
          }}
        />
        <div style={{ marginRight: "8px" }}>|</div>
        <LinkFile
          id="plan-template-return=shipping"
          component="button"
          variant="body2"
          value={TEMPLATE_NAME.RETURN_SHIPPING}
          onClick={() => handleDownloadTemplate("Return Shipping Plan")}
          props={{
            tabIndex,
          }}
        />
        <div style={{ marginRight: "8px" }}>|</div>
        <LinkFile
          id="plan-template-transferring"
          component="button"
          variant="body2"
          value={TEMPLATE_NAME.TRANSFERRING}
          onClick={() => handleDownloadTemplate("Transferring Plan")}
          props={{
            tabIndex,
          }}
        />
        <div style={{ marginRight: "8px" }}>|</div>
        <LinkFile
          id="plan-template-receiving"
          component="button"
          variant="body2"
          value={TEMPLATE_NAME.RECEIVING}
          onClick={() => handleDownloadTemplate("Receiving Plan")}
          props={{
            tabIndex,
          }}
        />
      </Box>
    </Fragment>
  );
}
